module.exports = __webpack_public_path__ + "static/img/smart_guard_icon.95bd5dfa.png";